import { DbRef } from "./firebase";
export var StepperStatusType;
(function (StepperStatusType) {
    StepperStatusType["PATIENT_VISIT"] = "patientVisit";
    StepperStatusType["DROP_OFF"] = "dropOff";
})(StepperStatusType || (StepperStatusType = {}));
export var DraftWaypointStatus;
(function (DraftWaypointStatus) {
    DraftWaypointStatus["CANCELED"] = "canceled";
    /** Draft waypoint created */
    DraftWaypointStatus["PENDING"] = "pending";
    /**
     * One of the proposed date options was accepted
     *
     * @deprecated
     * The current flow does not support picking a date without payment.
     */
    DraftWaypointStatus["ACCEPTED"] = "accepted";
    /** None of the proposed date options were accepted */
    DraftWaypointStatus["REJECTED"] = "rejected";
    /**
     * Payment for draft waypoint was completed if required, and the draft
     * waypoint is eligible to be converted to a real waypoint and added to an
     * itinerary.
     *
     * TODO: Implement payment for draft waypoints.
     * Until automatic payment is implemented, all draft waypoints will be
     * manually finalized in dashboard.
     */
    DraftWaypointStatus["FINALIZED"] = "finalized";
    /** Draft waypoint converted to real waypoint in an itinerary */
    DraftWaypointStatus["IN_ITINERARY"] = "inItinerary";
})(DraftWaypointStatus || (DraftWaypointStatus = {}));
export var DraftWaypointRejectionReason;
(function (DraftWaypointRejectionReason) {
    DraftWaypointRejectionReason["DAY_NOT_WORKING"] = "dayNotWorking";
    DraftWaypointRejectionReason["TIME_NOT_WORKING"] = "timeNotWorking";
    DraftWaypointRejectionReason["NO_NEED_FOR_NURSE"] = "noNeedForNurse";
    DraftWaypointRejectionReason["OTHER"] = "other";
})(DraftWaypointRejectionReason || (DraftWaypointRejectionReason = {}));
export var DraftWaypointSupplyStrategy;
(function (DraftWaypointSupplyStrategy) {
    /**
     * Warehouse assembles and ships a custom box of supplies based on the
     * procedure requirements.
     */
    DraftWaypointSupplyStrategy["CUSTOM_SHIPMENT"] = "customShipment";
    /**
     * Set if at least one procedure on the draft waypoint has products associated
     * with kit supplies (isKit: boolean). An external company will be responsible
     * for shipping the supplies to the patient. Additionally, for each of those
     * procedures, a mail-in sample shipment will be created and referenced at
     * `Procedure.sampleShipmentID`.  The nurse tasks related to mail-in will be
     * included in the patient waypoint action and no mail-in waypoint action will
     * be used.
     */
    DraftWaypointSupplyStrategy["KIT_SHIPMENT"] = "kitShipment";
    /**
     * No supplies shipped to the patient. The CarePro will pack supplies during
     * the itinerary.
     */
    DraftWaypointSupplyStrategy["OFFLINE_SUPPLIES"] = "offlineSupplies";
})(DraftWaypointSupplyStrategy || (DraftWaypointSupplyStrategy = {}));
export const draftWaypointSupplyStrategyLabels = {
    [DraftWaypointSupplyStrategy.CUSTOM_SHIPMENT]: 'Custom shipment',
    [DraftWaypointSupplyStrategy.KIT_SHIPMENT]: 'Kit shipment',
    [DraftWaypointSupplyStrategy.OFFLINE_SUPPLIES]: 'Offline supplies',
};
export const DraftWaypointRelationshipKeys = {
    itineraryID: { ref: DbRef.ITINERARIES },
    officeID: { ref: DbRef.OFFICES },
    procedures: { ref: DbRef.PROCEDURES },
    rejectionUserID: { ref: DbRef.USERS },
    finalizedByUserID: { ref: DbRef.USERS },
    suggestedNurseID: { ref: DbRef.USERS },
    supplyTransfers: { ref: DbRef.SUPPLY_TRANSFERS },
    transactions: { ref: DbRef.TRANSACTIONS },
    waypointID: { ref: DbRef.WAYPOINTS },
};
export var AlgoliaDraftWaypointTag;
(function (AlgoliaDraftWaypointTag) {
    /**
     * Whether to show the draft waypoint on the map and waypoint list when
     * creating an itinerary. Conditions:
     * - The draft waypoint is `finalized`, or
     * - The draft waypoint is `pending` and `batchEligible`
     */
    AlgoliaDraftWaypointTag["ALLOW_ADD_TO_ITINERARY"] = "allowAddToItinerary";
    /**
     * Whether to show the draft waypoint in the supply transfers list on
     * dashboard. A card will show for the draft waypoint if:
     * - It is `finalized` or `inItinerary`
     * - It was `canceled`, after a supply strategy was already selected
     */
    AlgoliaDraftWaypointTag["SHOW_IN_SUPPLY_TRANSFERS_LIST"] = "showInSupplyTransfersList";
})(AlgoliaDraftWaypointTag || (AlgoliaDraftWaypointTag = {}));
export const draftWaypointRejectionReasonLabels = {
    [DraftWaypointRejectionReason.DAY_NOT_WORKING]: 'Day doesn’t work',
    [DraftWaypointRejectionReason.TIME_NOT_WORKING]: 'Time doesn’t work',
    [DraftWaypointRejectionReason.NO_NEED_FOR_NURSE]: 'I don’t need this nurse visit',
    [DraftWaypointRejectionReason.OTHER]: 'Other',
};
//# sourceMappingURL=draftWaypoint.js.map